export default __webpack_public_path__ + "static/media/lathy.9f1f2d3a.png";